<template>
  <div>

  </div>
</template>

<script>
export default {
  name: 'PrevCheck',
  data () {
    return {}
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.$router.replace({
        path: '/login',
        query: {
          redirect: '/ldh/ent/' + this.$route.params.url
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
